import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Graphic from './Graphic.js';

const ScriptGraphics = ({effect, graphics=[]}) => { 
    let [scriptGraphics, setScriptGraphics] = useState(graphics);
    useEffect(() => {
        if (graphics.length > 0) {
            setScriptGraphics(graphics);
        }
    }, [graphics, setScriptGraphics]);
    if (scriptGraphics.length === 0) {
        return [];
    }
    return (
        <svg className="script-graphics">
          {scriptGraphics.map(
              graphic => <Graphic graphic={graphic}/>)}
        </svg>);
};

const mapStateToProps = (state, props) => {
  return {
      graphics: props.effect.graphics
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScriptGraphics);
